import React,{useState} from 'react'
import Avatar from 'components/Avatar'
import { Col, Row, Empty,Pagination, Dropdown } from 'antd'
import Button from 'components/Button'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import {
  Name,
  Name1,
  Address,
  NameAdd,
  FullTable,
  SlRow,
  SlCol,
  SlCol1,
  LeftAlignCol,
  ContentCenterDiv,
} from 'modules/OfferLetter/Style/style'
import OfferDetailDrawer from './OfferDetailDrawer'
import RejectOfferDrawer from './RejectOfferDrawer'
import NegotiateOfferDrawer from './NegotiateOfferDrawer'
import SuccessNegotiateOfferDrawer from './SuccessNegotiateOfferDrawer '
import moment from 'moment'
import { formatNumber } from 'utils/formatNumber'
import CustomTag from 'components/CustomTag'
import {
  ActionMenu,
  ItemText
} from 'components/ActionStyles/ActionStyles'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { StyledAnchor } from '../../Dashboard/Style/style'

const SingleListed = ({
  offerLetterList,
  OfferAcceptReject,
  onPageChange,
  page,
  filter,
  getUserCorpList,
  sendNotificationBulkEmail,
  offerAccpectTemplate,
  offerRejectTemplate,
  offerRejectTemplateEx,
  candidateJoined,
  setFilter,
  updateDataCall,
  sendInAppNotification,
  offerNegotiateTemplate,
  getOfferList,
}) => {
  const navigate = useNavigate()
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const [drawerOffer, setDrawerOffer] = useState(false)
  const [drawerReject, setDrawerReject] = useState(false)
  const [drawerNegotiate, setDrawerNegotiate] = useState(false)
  const [drawerSuccess, setDrawerSuccess] = useState(false)
  const [selectedoffer, setSelectedOffer] = useState()
  const menu = (
    <ActionMenu
      width={'190px'}
      items={[
        {
          key: 'Upload Document',
          label: <ItemText>Upload Document</ItemText>,
          disabled: !selectedoffer?.candidateDocReqStatus,
          onClick: () => uploadDoc(),
        },
        {
          key: 'Join',
          label: <ItemText>Join</ItemText>,
          disabled: selectedoffer?.jobRoleStudentMap?.offerStatus === 'JOINED',
          onClick: () => updateStatus(),
        },
      ]}
    />
  )
  const updateStatus = () => {
    candidateJoined(selectedoffer?.roleId, selectedoffer?.driveId)
  }
  const uploadDoc = () => {
    navigate(`/offerReceived/uploadDocument/${selectedoffer?.id}`)
  }

  const CheckIcon = logo => {
    if (logo === null) {
      return (
        <Avatar
          size={42}
          src={<ApartmentIcon />}
          boxShadow={true}
          padding={'3px'}
        />
      )
    } else {
      return <Avatar size={42} src={logo} />
    }
  }

  const onChange = key => {
    onPageChange(key)
  }

  const showDrawer = (event, param) => {
    setSelectedOffer(param)
    setDrawerOffer(true)
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  return (
    <>
      <FullTable>
        {offerLetterList?.result?.map((item, index) => (
        
            <SlRow key={index+"result"}>
              <SlCol1>
                <Row>
                  <Col>{CheckIcon(item?.role?.corporate?.logo)}</Col>
                  <LeftAlignCol>
                    <NameAdd column flexStart>
                      <Name1>{item?.role?.corporate?.name}</Name1>
                      <Address>{item?.role?.tittle}</Address>
                    </NameAdd>
                  </LeftAlignCol>
                </Row>
              </SlCol1>

              <SlCol>
                <NameAdd column flexStart>
                  <Address>Salary</Address>
                  <Name>
                    {' '}
                    ₹ {formatNumber(item?.salary)}{' '}
                    {item.frequecy === 'ANNUALLY' ? ` per annum` : ` per month`}
                  </Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Level </Address>
                  <Name>
                    {item?.role?.rolePublishedBy == 'INSTITUTE'
                      ? checkJobCategory(item?.role?.jobCategory)
                      : checkJobTypeLevel(
                          item?.role?.jobTypeLevels,
                          item?.role?.yearOfExperience
                        )}{' '}
                    (
                    {item?.role?.jobType === 'FULL_TIME'
                      ? 'Full Time'
                      : 'Part Time'}
                    )
                  </Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Offer Received on </Address>
                  <Name>{moment(item?.createdAt)?.format('DD/MM/YYYY')}</Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                <NameAdd column flexStart>
                  <Address>Offer Valid</Address>
                  <Name>
                    {moment(item?.offerExpireDate)?.format('DD/MM/YYYY')}
                  </Name>
                </NameAdd>
              </SlCol>
              <SlCol>
                {item?.jobRoleStudentMap?.offerStatus === 'RELEASED' &&
                filter != 'EXPIRED' ? (
                  <Button.Secondary
                    onClick={event => showDrawer(event, item)}
                    text={'Accept/Decline'}
                    width={'120px'}
                    borderRadius={'15px'}
                  />
                ) : item?.jobRoleStudentMap?.offerStatus === 'REJECTED' &&
                  filter != 'EXPIRED' ? (
                  <CustomTag
                    message={'Declined'}
                    bordered={true}
                    background="#FDF2F1"
                    colorType="#E97E73"
                    border="#FDF2F1"
                  />
                ) : item?.jobRoleStudentMap?.offerStatus === 'ACCEPTED' &&
                  filter != 'EXPIRED' ? (
                  <CustomTag
                    message={'Accepted'}
                    bordered={true}
                    background="#DFF0EA"
                    colorType="#5DB594"
                    border="#DFF0EA"
                  />
                ) : item?.jobRoleStudentMap?.offerStatus === 'JOINED' &&
                  filter != 'EXPIRED' ? (
                  <CustomTag
                    message={'Joined'}
                    bordered={true}
                    background="#DFF0EA"
                    colorType="#5DB594"
                    border="#DFF0EA"
                  />
                ) : item?.jobRoleStudentMap?.offerStatus === 'NEGOTIATED' &&
                  filter != 'EXPIRED' ? (
                  <CustomTag
                    message={'Negotiated'}
                    bordered={true}
                    background="#DFF0EA"
                    colorType="#5DB594"
                    border="#DFF0EA"
                  />
                ) : filter === 'EXPIRED' ? (
                  <CustomTag
                    message={'Expired'}
                    bordered={true}
                    background="#FEF8F3"
                    colorType="#F3A66E"
                    border="#FEF8F3"
                  />
                ) : null}
              </SlCol>
              {(item?.jobRoleStudentMap?.offerStatus === 'ACCEPTED' ||
                item?.jobRoleStudentMap?.offerStatus === 'JOINED') &&
                filter != 'EXPIRED' &&
                stdData?.isExpCandidate && (
                  <SlCol>
                    <Dropdown overlay={menu} trigger={['click']}>
                      <StyledAnchor onClick={e => e.preventDefault()} >
                        <Button.Round
                          onClick={event => setSelectedOffer(item)}
                          icon={<VerticalThreeDots />}
                        />
                      </StyledAnchor>
                    </Dropdown>
                  </SlCol>
                )}
            </SlRow>
          
        ))}
      </FullTable>
      {drawerOffer && (
        <OfferDetailDrawer
          drawer={drawerOffer}
          selectedoffer={selectedoffer}
          setDrawer={setDrawerOffer}
          setDrawerReject={setDrawerReject}
          OfferAcceptReject={OfferAcceptReject}
          getUserCorpList={getUserCorpList}
          offerAccpectTemplate={offerAccpectTemplate}
          offerRejectTemplate={offerRejectTemplate}
          offerRejectTemplateEx={offerRejectTemplateEx}
          sendNotificationBulkEmail={sendNotificationBulkEmail}
          sendInAppNotification={sendInAppNotification}
          setDrawerNegotiate={setDrawerNegotiate}
          getOfferList={getOfferList}
        />
      )}
      {drawerReject && (
        <RejectOfferDrawer
          drawer={drawerReject}
          selectedoffer={selectedoffer}
          setDrawer={setDrawerReject}
          OfferAcceptReject={OfferAcceptReject}
          getUserCorpList={getUserCorpList}
          offerAccpectTemplate={offerAccpectTemplate}
          offerRejectTemplate={offerRejectTemplate}
          offerRejectTemplateEx={offerRejectTemplateEx}
          sendNotificationBulkEmail={sendNotificationBulkEmail}
          sendInAppNotification={sendInAppNotification}
          getOfferList={getOfferList}
        />
      )}
      {drawerNegotiate && (
        <NegotiateOfferDrawer
          drawer={drawerNegotiate}
          selectedoffer={selectedoffer}
          setDrawer={setDrawerReject}
          setDrawerNegotiate={setDrawerNegotiate}
          setDrawerSuccess={setDrawerSuccess}
          OfferAcceptReject={OfferAcceptReject}
          offerRejectTemplateEx={offerRejectTemplateEx}
          offerNegotiateTemplate={offerNegotiateTemplate}
          getUserCorpList={getUserCorpList}
          sendNotificationBulkEmail={sendNotificationBulkEmail}
          onPageChange={onPageChange}
          setFilter={setFilter}
          updateDataCall={updateDataCall}
          getOfferList={getOfferList}
        />
      )}
      {drawerSuccess && (
        <SuccessNegotiateOfferDrawer
          drawer={drawerSuccess}
          setDrawer={setDrawerSuccess}
        />
      )}
      {offerLetterList?.count === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <ContentCenterDiv>
          <br></br>
          <Pagination
            current={page}
            total={offerLetterList?.count}
            onChange={onChange}
            defaultCurrent={1}
          />
        </ContentCenterDiv>
      )}
    </>
  )
}
export default SingleListed
